import Splide from '@splidejs/splide';

let quoteSlider = document.getElementsByClassName('quote-slider');

document.addEventListener('DOMContentLoaded', function () {
    if (quoteSlider.length > 0) {
        for (let i = 0; i < quoteSlider.length; i++) {
            let splide = new Splide(quoteSlider[i], {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                rewind: true,
                pagination: false,
                arrows: true,
                width: '100%'
            });

            let arrows = splide.root.querySelector('.splide__arrows');

            splide.on('mounted', function () {
                //Check if there is a next slide
                let nextSlide = splide.Components.Controller.getNext()

                //If not then remove slider arrows
                if (nextSlide < 0) {
                    arrows.style.display = 'none';
                }
            });

            splide.mount();
        }
    }
});


